<template>
  <div class="info" :class="{ 'without-arrow': !arrow }">
    <div class="info__text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Info",
  props: {
    text: {
      type: String,
      default: null,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.info {
  border: 1px solid $red;
  border-radius: 4px;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.2rem;
  color: $red;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
  min-width: 12rem;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 2;
  background: $white;
  white-space: nowrap;
  &.without-arrow {
    &:after,
    &:before {
      display: none;
    }
  }
  &:after {
    content: "";
    position: absolute;
    bottom: -0.5rem;
    left: 2rem;
    background: $white;
    border: 1px solid $red;
    width: 0.8rem;
    height: 0.8rem;
    transform: rotate(-45deg);
    border-top: none;
    border-right: none;
    z-index: 0;
  }
  &:before {
    content: "";
    position: absolute;
    z-index: 1;
    width: calc(100% - 2px);
    height: calc(100% - 1px);
    background: $white;
    top: 1px;
    left: 1px;
  }
  &__text {
    position: relative;
    z-index: 2;
  }
}
</style>
